import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2EditComponent } from './fi-checklist2-edit.component';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FormsModule } from '@angular/forms';
import { FiChecklist2CheckpointSectionEditModule } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-section-edit.module';
import { FiChecklist2GeneralSectionEditModule } from '@fi-shared/checklist/fi-checklist2-edit/general-section-edit/general-section-edit.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiChecklistCommonDataDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/checklist-common-data-dialog/checklist-common-data-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiChecklistAddChecklistDialogComponent } from '@fi-shared/checklist/fi-checklist2-edit/add-checklist-dialog/add-checklist-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { ChecklistAiAssistanceModule } from '@fi-shared/checklist/fi-checklist2-edit/checklist-ai-assistance/checklist-ai-assistance.module';
import { FiChecklistEditorStoreService } from '@fi-shared/checklist/fi-checklist-editor-store.service';
import { FiChecklist2SharedModule } from '@fi-shared/checklist/fi-checklist2-shared/fi-checklist2-shared.module';
import { FiNameDescriptionInputModule } from '@fi-shared/name-description-input/name-description-input.module';

@NgModule({
    imports: [
        CommonModule,
        FiValidatingFormModule,
        FormsModule,
        FiChecklist2CheckpointSectionEditModule,
        FiChecklist2GeneralSectionEditModule,
        ChecklistAiAssistanceModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        FiAppTextSharedModule,
        MatInputModule,
        MatDividerModule,
        FiAttachmentsModule,
        InfoIconModule,
        MatTooltipModule,
        MatRadioModule,
        SelectSearchModule,
        FiChecklist2SharedModule,
        FiNameDescriptionInputModule,
    ],
    declarations: [
        FiChecklist2EditComponent,
        FiChecklistCommonDataDialogComponent,
        FiChecklistAddChecklistDialogComponent,
    ],
    exports: [FiChecklist2EditComponent],
    providers: [FiChecklistEditorStoreService],
})
export class FiChecklist2EditModule {}
